module.exports = __webpack_public_path__ + "whatsapp-new-edb2be7dcd65968af0e6.svg";